<template>
  <div
    v-if="NIVEL_EXPANCAO && NIVEL_EXPANCAO > 0"
    class="d-flex"
  >
    <template v-for="nivel in (NIVEL_EXPANCAO - 1)">
      <div
        :style="{height: `${altura}px`}"
        :key="nivel"
        class="mr-7px"
      >
        <div class="barra mx-auto my-1" />
        <div class="barra mx-auto my-1" />
        <div class="bola mx-auto my-1" />
        <div class="barra mx-auto my-1" />
        <div class="barra mx-auto my-1" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "MarcadorDeItentacao",
  props: {
    linha: Object,
    nivel_expancao: Number,
    altura: Number
  },
  computed: {
    NIVEL_EXPANCAO() {
      if (this.linha) {
        return this.linha.nivel_expancao
      }

      return this.nivel_expancao;
    }
  }
}
</script>

<style scoped>
.mr-7px {
  margin-right: 9px;
}
.barra {
  background: #94B6E9;
  width: 1px;
  height: 5px;
}
.bola {
  background: #94B6E9;
  width: 5px;
  height: 5px;
}
</style>
